import { ChargeConstant } from "presentation/constant/ChargeHeader/ChargeConstant";
import { ChargeHeaderCriteriaDirectoryVoyageCheckboxOption } from "presentation/constant/ChargeHeader/ChargeHeaderCriteriaDirectoryCheckboxOption";
import { chargeHeadergGroupRadioOption } from "presentation/constant/RadioOptions/StaticRadioOptions";
import { useChargeHeaderMaintenanceVM } from "presentation/hook/ChargeHeaderMaintenance/useChargeHeaderMaintenanceVM";
import { useChargeHeaderMaintenanceTracked } from "presentation/store/ChargeHeaderMaintenance/ChargeHeaderMaintenanceProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import DateRangePickerComponent from "presentation/view/components/DateRangePickerComponent";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { useMemo } from "react";
import {
    FieldType,
    GroupCheckboxList,
    HPHGroupCheckbox,
    HPHGroupRadioButton,
    IFieldValue
} from "veronica-ui-component/dist/component/core";


export const ChargeHeaderSearchCriteriaEditVoyagePanel = () => {
    const [chargeDataSearchState] = useChargeHeaderMaintenanceTracked();
    const CHARGE_HEADER_CONSTANT = ChargeConstant.ChargeHeader;
    const chargeDataSearchCriteria = chargeDataSearchState.searchCriteria;
    const chargeDataSearchVM = useChargeHeaderMaintenanceVM();
    const enabledCriteria = useMemo(() => ChargeHeaderCriteriaDirectoryVoyageCheckboxOption?.find(item => chargeDataSearchState.enabledSearchCriteria[item.key]), [chargeDataSearchState.enabledSearchCriteria]);
    const selectedHdrGroup = chargeDataSearchCriteria.tempHdrGroupName;

    const memoHeaderGroup = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "190px", maxWidth: "410px", width: "100%", marginBottom: "24px" }}>
            <HPHGroupRadioButton
                label="Charge Group"
                width='100%'
                radioOptions={chargeHeadergGroupRadioOption}
                value={chargeDataSearchCriteria.tempHdrGroupName ?? ""}
                onChange={(e) => chargeDataSearchVM.onRadioChange(e, 'tempHdrGroupName')}
                checked={chargeHeadergGroupRadioOption?.find(item => item.key === chargeDataSearchCriteria.tempHdrGroupName)?.name}
            />
        </div>
        , [chargeDataSearchCriteria.tempHdrGroupName, chargeDataSearchVM])

    const memoVslCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "190px", maxWidth: "190px", width: "47.5%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDataSearchCriteria.vesselCode || ''}
                fieldValue={chargeDataSearchCriteria.vesselCode}
                fieldLabel={CHARGE_HEADER_CONSTANT.VESSEL_CODE}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'vesselCode'}
                maxLength={6}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDataSearchVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CHARGE_HEADER_CONSTANT.VESSEL_CODE, chargeDataSearchCriteria.vesselCode, chargeDataSearchVM])

    const memoVoyCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "190px", maxWidth: "190px", width: "47.5%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDataSearchCriteria.voyageCode || ''}
                fieldValue={chargeDataSearchCriteria.voyageCode}
                fieldLabel={CHARGE_HEADER_CONSTANT.VOYAGE_CODE}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'voyageCode'}
                maxLength={10}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDataSearchVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CHARGE_HEADER_CONSTANT.VOYAGE_CODE, chargeDataSearchCriteria.voyageCode, chargeDataSearchVM])


    const memoVslName = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "190px", maxWidth: "190px", width: "47.5%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDataSearchCriteria.vesselName || ''}
                fieldValue={chargeDataSearchCriteria.vesselName}
                fieldLabel={CHARGE_HEADER_CONSTANT.VESSEL_NAME}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'vesselName'}
                maxLength={30}
                isTextFieldCapitalize={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDataSearchVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CHARGE_HEADER_CONSTANT.VESSEL_NAME, chargeDataSearchCriteria.vesselName, chargeDataSearchVM])

    const memoConsortiumCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "190px", maxWidth: "190px", width: "47.5%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={chargeDataSearchCriteria.consortiumCode || ''}
                fieldValue={chargeDataSearchCriteria.consortiumCode}
                fieldLabel={CHARGE_HEADER_CONSTANT.CONSORTIUM_CODE}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'consortiumCode'}
                maxLength={30}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    chargeDataSearchVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CHARGE_HEADER_CONSTANT.CONSORTIUM_CODE, chargeDataSearchCriteria.consortiumCode, chargeDataSearchVM])


    const memoEtdFromTo = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "190px", maxWidth: "410px", width: "100%", marginBottom: "24px" }}>
            <DateRangePickerComponent
                label={ChargeConstant.Charge.ETD_RANGE}
                width='100%'
                fieldNames={{ startField: "etdDateFrom", endField: "etdDateTo" }}
                dateRange={{ startDate: chargeDataSearchCriteria.etdDateFrom, endDate: chargeDataSearchCriteria.etdDateTo }}
                onDatesChange={chargeDataSearchVM.onDateRangeChange}
            />
        </div>
        , [chargeDataSearchCriteria.etdDateFrom, chargeDataSearchCriteria.etdDateTo, chargeDataSearchVM.onDateRangeChange])

    const memoOpsDateFromTo = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "190px", maxWidth: "410px", width: "100%", marginBottom: "24px" }}>
            <DateRangePickerComponent
                label={CHARGE_HEADER_CONSTANT.OPS_DATE_RANGE}
                width='100%'
                fieldNames={{ startField: "opsDateFrom", endField: "opsDateTo" }}
                dateRange={{ startDate: chargeDataSearchCriteria.opsDateFrom, endDate: chargeDataSearchCriteria.opsDateTo }}
                onDatesChange={chargeDataSearchVM.onDateRangeChange}
            />
        </div>
        , [CHARGE_HEADER_CONSTANT.OPS_DATE_RANGE, chargeDataSearchCriteria.opsDateFrom, chargeDataSearchCriteria.opsDateTo, chargeDataSearchVM.onDateRangeChange])

    const memoState = useMemo(() =>
        <>
            <div className='im-flex-row-item' style={{ marginBottom: "24px" }}>
                <HPHGroupCheckbox
                    label={CHARGE_HEADER_CONSTANT.HEADER_STATE}
                    checkboxData={[
                        { key: "NIL", name: "NIL", disabled: false },
                        { key: "CFM", name: "CFM", disabled: false },
                        { key: "TML", name: "TML", disabled: false },
                        { key: "INV", name: "INV", disabled: false }
                    ]}
                    selectedValues={chargeDataSearchState.searchCriteria.stateList}
                    orientation={"horizontal"}
                    onChange={(e: (GroupCheckboxList | undefined)[]) => chargeDataSearchVM.onGroupCheckboxChange(e, chargeDataSearchState.searchCriteria, "stateList")}
                />
            </div>
        </>
        , [CHARGE_HEADER_CONSTANT.HEADER_STATE, chargeDataSearchVM, chargeDataSearchState.searchCriteria])

    return (
        enabledCriteria ? <>
            <CriteriaItemContainer>
                {memoHeaderGroup}
            </CriteriaItemContainer>

            <CriteriaItemContainer>
                {chargeDataSearchState.enabledSearchCriteria.stateList ? memoState : null}
            </CriteriaItemContainer>

            <CriteriaItemContainer>
                {selectedHdrGroup === "VESSEL" ? memoVslCode : null}
                {selectedHdrGroup === "VESSEL" ? memoVoyCode : null}
            </CriteriaItemContainer>

            <CriteriaItemContainer>
                {selectedHdrGroup === "VESSEL" ? memoVslName : null}
                {selectedHdrGroup === "VESSEL" ? memoConsortiumCode : null}
            </CriteriaItemContainer>

            <CriteriaItemContainer>
                {selectedHdrGroup === "VESSEL" ? memoEtdFromTo : null}
            </CriteriaItemContainer>

            <CriteriaItemContainer>
                {selectedHdrGroup === "OPS_DATE" ? memoOpsDateFromTo : null}
            </CriteriaItemContainer>
        </> : null
    );
};
